
import React from 'react';

export const ArrowRightIcon = () => (
  <svg className="w-4 h-4" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.5 8.41187H12.5" stroke="#1B1C1E" strokeLinecap="square" strokeLinejoin="round" />
    <path d="M9 3.91187L13.5 8.41187L9 12.9119" stroke="#1B1C1E" strokeLinecap="square" />
  </svg>
);
